import { render, staticRenderFns } from "./BaseSelectWithBox.vue?vue&type=template&id=4ab79a46&scoped=true"
import script from "./BaseSelectWithBox.vue?vue&type=script&lang=js"
export * from "./BaseSelectWithBox.vue?vue&type=script&lang=js"
import style0 from "./BaseSelectWithBox.vue?vue&type=style&index=0&id=4ab79a46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab79a46",
  null
  
)

export default component.exports